module.exports = __webpack_public_path__ + "img/zt_pic1.20a048f2.png";